/**
 * Toggles a value in a multi-select where one option is mutually exclusive
 * with all the others (a "none of the above" option).
 *
 * - Selecting the `noneOption` clears every other selection.
 * - Selecting any other option deselects the `noneOption`.
 *
 * The "none" label is passed in because it differs between questions
 * (e.g. "inget av ovanstående", "Inget av ovanstående",
 * "Nej, inget av ovanstående").
 */
export const toggleExclusive = (
  currentSelection: string[],
  value: string,
  noneOption: string
): string[] => {
  const isChecked = currentSelection.includes(value);

  if (value === noneOption) {
    return isChecked ? [] : [value];
  }

  const withoutNone = currentSelection.filter((item) => item !== noneOption);
  return isChecked
    ? withoutNone.filter((item) => item !== value)
    : [...withoutNone, value];
};
